<template>
  <div class="ticket-page">
    <van-icon name="passed" size="60" color="#07c160" />
    <div class="text">支付已完成</div>
    <!-- Vue 2 中直接调用 methods 里的方法 -->
    <van-button type="primary" round block @click="goToPayLoading">
      返回
    </van-button>
  </div>
</template>

<script>
import {
  Toast
} from 'vant'
import { getLocalWithExpiry } from '@/utils/localStorageUtil'

export default {
  name: 'MerchantTicket',
  // Vue 2 的生命周期钩子
  mounted () {
    const WX_PAY_URL = 'https://payapp.weixin.qq.com'
    const orderCode = getLocalWithExpiry('currentOrderCode')

    // 容错处理
    if (!orderCode) {
      Toast('正在为您返回...')
      setTimeout(() => {
        const jumpData = {
          action: 'jumpOut',
          jumpOutUrl: 'https://wx.qianbaokj.cn/#/QueryRecharge'
        }
        window.parent.postMessage(JSON.stringify(jumpData), WX_PAY_URL)
      }, 2000)
      return
    }
    const jumpData = {
      action: 'jumpOut',
      jumpOutUrl: `https://wx.qianbaokj.cn/#/PayV2Loading/${orderCode}` // 请替换为你的 HTTPS 地址
    }
    window.parent.postMessage(JSON.stringify(jumpData), WX_PAY_URL)
    // // 告诉微信父容器展示自定义页面
    // const initData = {
    //   action: 'onIframeReady',
    //   displayStyle: 'SHOW_CUSTOM_PAGE'
    // }
    // window.parent.postMessage(JSON.stringify(initData), WX_PAY_URL)
  },
  // Vue 2 的方法必须写在 methods 对象里
  methods: {
    goToPayLoading () {
      const WX_PAY_URL = 'https://payapp.weixin.qq.com'
      const orderCode = getLocalWithExpiry('currentOrderCode')
      let targetUrl = ''

      if (orderCode) {
        targetUrl = `https://wx.qianbaokj.cn/#/PayV2Loading/${orderCode}`
      } else {
        Toast('正在返回首页...')
        targetUrl = 'https://wx.qianbaokj.cn/#/QueryRecharge'
      }

      const jumpData = {
        action: 'jumpOut',
        jumpOutUrl: targetUrl
      }
      window.parent.postMessage(JSON.stringify(jumpData), WX_PAY_URL)
    }
  }
}
</script>

<style scoped>
  /* 样式部分保持不变 */
  .ticket-page {
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    background-color: #fff;
  }

  .text {
    margin: 20px 0 40px;
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .van-button {
    width: 80%;
  }
</style>
